import { css, html, LitElement } from 'lit-element';
import query from '@giswebgroup/ki-wcp-base/src/decorators/query';
import autoRun from '@giswebgroup/ki-wcp-base/src/decorators/autoRun';
import i18n from '@giswebgroup/ki-wcp-base/src/decorators/i18n';
import nls from '../../locales/index.nls';

export default
@i18n(nls)
class KiStationListItem extends LitElement {
  static styles = css`
    :host {
      display: block;
      width: 100%;
    }
    .menu-wrapper {
      line-height: 40px;
      display: flex;
      flex-direction: row;
      padding-left: 40px;
    }

    .label {
      flex: 1;
      max-width: 340px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .icon {
      padding: 10px 15px;
    }
    .icon.displaynone {
      display: none;
    }

    .icon:hover {
      cursor: pointer;
      color: var(--theme-color, #0056a0);
    }
    .label:hover {
      cursor: pointer;
      color: var(--theme-color, #0056a0);
    }
    .hidden {
      height: 0;
      transition: height 0.4s ease-in-out;
    }

    ki-list.hidden ki-list-item {
      display: none;
    }

    ki-list-item {
      line-height: 24px;
      height: 24px;
      padding-left: 60px;
    }

    ki-list{
      padding-left: 50px;
    }

    ki-list-item:hover {
      cursor: pointer;
    }

    ki-list-item.selected {
      background: var(--theme-color, #0056a0);
      color: white;
    }
  `;

  @query('#label')
  __labelElement;

  static get properties() {
    return {
      data: { type: Object },
      expand: { type: Boolean }, // expand or collapse list
      selectedTs: { type: Array }, // use to judge selected
      selected: { type: Boolean },
    };
  }

  constructor() {
    super();
    this.data = {};
    this.selectedTs = [];
    this.expand = false;
    this.selected = false;
  }

  render() {
    // eslint-disable-next-line camelcase
    this.selected = this.selectedTs && this.selectedTs.indexOf(this.data?.ts_path) !== -1;
    return this.data
      ? html` <div class="menu-wrapper">
            <div class="label" id="label" @click="${this._handleLabelClick}">${this.data.label}</div>
            <ki-icon
              class="icon ${this.data.ts_path ? '' : 'displaynone'}"
              icon="ki ${this.expand ? 'ki-chevron-up' : 'ki-chevron-down'}"
              @click="${() => {
                this.expand = !this.expand;
              }}"
            ></ki-icon>
          </div>
          <ki-list class="${this.expand ? '' : 'hidden'}">
            <ki-list-item @click="${this._handleClick}" class="${this.selected ? 'selected' : ''}">
              <ki-icon icon="ki ki-line-chart2"></ki-icon>
              ${this._createLabel(this.data.stationparameter_name)}</ki-list-item
            >
          </ki-list>`
      : ``;
  }

  @autoRun('__labelElement')
  _createPapertooltip() {
    // if (this.__labelElement.offsetWidth < this.__labelElement.scrollWidth) {
    // not working when the sidebar is not shown
    this.__labelElement.title = this.data.label
/*    const node = document.createElement('paper-tooltip');
    node.for = 'label';
    node.innerHTML = this.data.label;
    this.__labelElement.appendChild(node); */
    // }
  }

  // create label for i18n ts names
  // eslint-disable-next-line class-methods-use-this
  _createLabel(label = 'Data') {
    //   let tsShortName = tsPath.slice(tsPath.lastIndexOf('/') + 1); // cmdxx.total
    // tsShortName = tsShortName.replaceAll('.', '_'); // not support name/prop with .
    return this.i18n.t(label) || label;
  }

  _handleLabelClick() {
    this.dispatchEvent(
      new CustomEvent('labelClicked', {
        detail: { value: this.data.value },
        bubbles: true,
        composed: true,
      }),
    );
  }

  _handleClick() {
    this.dispatchEvent(
      new CustomEvent('itemSelected', {
        detail: {
          // eslint-disable-next-line camelcase
          value: this.data.ts_path,
          selected: this.selected,
        },
        bubbles: true,
        composed: true,
      }),
    );
  }
}

customElements.define('ki-station-list-item', KiStationListItem);
